/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './site-settings.scss';

/* eslint-disable import/no-unresolved, import/default */

import siteSettingsTemplate from './site-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siteSettings', [])
    .directive('agSiteSettings', SiteSettings)
    .name;

/*@ngInject*/
function SiteSettings() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SiteSettingsController,
        controllerAs: 'vm',
        templateUrl: siteSettingsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiteSettingsController($rootScope, $scope, $translate, agTypes, agUtils, siteService, userService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siteId = null;
    vm.site = null;
    vm.allowEditSettings = true;

    var user = userService.getCurrentUser();

    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowEditSettings = false;
        }
    }

    vm.helpPageAction = agUtils.createHelpActionConfig("agSite");

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;
            vm.siteId = null;
            if (vm.ctx.stateController) {
                vm.siteId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSite();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiteId, prevSiteId) {
                    if (newSiteId && !angular.equals(newSiteId, prevSiteId)) {
                        vm.siteId = newSiteId;
                        loadSite();
                    }
                }
            );
        }
    });

    $scope.$watch(function() { return vm.site ? (vm.site.label || vm.site.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.site.site-settings') + ': ' + title;
        }
    });

    $scope.$watch('vm.site.label', () => {
        if (vm.site && !$scope.theForm.$invalid) {
            siteService.saveSite(vm.site).then(function success() {
                $rootScope.$broadcast('siteAssetUpdated', vm.site);
            });
        }
    });

    function loadSite() {
        vm.site = null;
        if (vm.siteId) {
            vm.loading = true;
            siteService.getSite(vm.siteId).then(
                (site) => {
                    vm.site = site;
                    vm.loading = false;
                },
                () => {
                    vm.loading = false;
                }
            );
        }
    }

}